export const appConfig = {
     baseAPIURL: process.env.VUE_APP_BaseAPIURL || 'https://api.dev.partssearch.com.au',
     appURL: process.env.VUE_APP_APPURL ? process.env.VUE_APP_APPURL : 'https://stw.dev.partssearch.com.au',
     psAppUrl: process.env.VUE_APP_APPURL ? process.env.VUE_APP_APPURL : 'https://stw.dev.partssearch.com.au',
     homeURL: process.env.VUE_APP_HomeURL ? process.env.VUE_APP_HomeURL : 'https://statewide.dev.partssearch.com.au',
};
